import { observable } from "mobx";
import { Type } from "class-transformer";
import VehicleRegisterVehiclePropertyChangeDisplayType from "./vehicleRegisterVehiclePropertyChangeDisplayType";
import VehicleRegisterVehicleChangeOrigin from "./vehicleRegisterVehicleChangeOrigin";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class VehicleRegisterVehicleChangeResponse {
  /**
   * Changed at.
   */
  @observable
  @Type(() => Date)
  changedAt!: Date;

  @observable
  changeType!: VehicleRegisterVehiclePropertyChangeDisplayType;

  /**
   * Original value, only specified for changes other than vehicle parameters or vehicle ID change.
   */
  @observable
  originalValue?: string;

  /**
   * New value, only specified for changes other than vehicle parameters or vehicle ID change.
   */
  @observable
  newValue?: string;

  /**
   * Changed by.
   */
  @observable
  changedBy?: string;

  @observable
  changeOrigin!: VehicleRegisterVehicleChangeOrigin;
}
